import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57cb753c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "aligin-cneter"
}, [/*#__PURE__*/_createElementVNode("h2", {
  style: {
    "color": "red"
  }
}, "postion for attention"), /*#__PURE__*/_createElementVNode("h2", {
  style: {
    "color": "red"
  }
}, "注意事项")]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "1.Please prepare relevant product technical documents according to the email requirements"), /*#__PURE__*/_createElementVNode("p", {
  class: "indent"
}, "请按邮件要求准备相关产品技术文件；"), /*#__PURE__*/_createElementVNode("p", null, "2.Please place the file in a compressed file for uploading"), /*#__PURE__*/_createElementVNode("p", {
  class: "indent"
}, "请将文件放置一个压缩文件中，进行上传操作；"), /*#__PURE__*/_createElementVNode("p", null, "3.This link can only upload a file once. Please carefully confirm the file content before uploading； "), /*#__PURE__*/_createElementVNode("p", {
  class: "indent"
}, "此链接仅可上传一次文件，请仔细确认文件内容后，再进行上传；"), /*#__PURE__*/_createElementVNode("p", null, "4.When uploading files, do not close the page until the page prompts that the upload is successful； "), /*#__PURE__*/_createElementVNode("p", {
  class: "indent"
}, "文件上传时，请勿关闭页面，直至页面提示上传成功；")])], -1));
const _hoisted_2 = {
  key: 4,
  class: "el-upload__text"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "把文件拖到这里或点击这里上传技术文件", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_upload_filled = _resolveComponent("upload-filled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createElementVNode("h1", null, _toDisplayString(_ctx.loadData.company_name), 1)]),
      _: 1
    }), _createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_el_card, {
        "body-style": {
          background: 'rgba(0, 0, 0, .1)'
        }
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_upload, {
          ref: "uploadRef",
          drag: "",
          "auto-upload": false,
          "on-change": $options.getFile,
          limit: 1,
          disabled: $data.uploading
        }, {
          default: _withCtx(() => [$data.uploading ? (_openBlock(), _createBlock(_component_el_progress, {
            key: 0,
            type: "circle",
            percentage: $data.uploadPercentage
          }, null, 8, ["percentage"])) : _createCommentVNode("", true), $data.success ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 1,
            title: "上传成功，感谢您的配合",
            type: "success",
            center: "",
            "show-icon": ""
          })) : _createCommentVNode("", true), $data.errorMsg != '' ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 2,
            title: $data.errorMsg,
            type: "error",
            center: "",
            "show-icon": ""
          }, null, 8, ["title"])) : _createCommentVNode("", true), !$data.uploading ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 3,
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_upload_filled)]),
            _: 1
          })) : _createCommentVNode("", true), !$data.uploading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createTextVNode(" Drop file here or click to upload "), _hoisted_3])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["on-change", "disabled"])]),
        _: 1
      }, 8, ["body-style"]), $setup.error_ref ? (_openBlock(), _createBlock(_component_el_alert, {
        key: 0,
        title: _ctx.loadData.msg,
        type: "error",
        center: "",
        "show-icon": ""
      }, null, 8, ["title"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  });
}